<template>
    <shortcuts-modern :model="model" />
</template>

<script>
import ShortcutsModern from './ShortcutsModern.vue';

export default {
    props: ['model'],
    components: {
        ShortcutsModern
    },
    data() {
        return {
        };
    },
};
</script>


